import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-bank-aggregator',
  template: `
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>account_balance</mat-icon>
  </div>
  <div class="description">
    <strong>Finicity Bank Statement Repull</strong>

    <div class="text">
      <span>by {{ activity.meta['lenderUserName'] }}</span>
    </div>
  </div>
  `,
  styles: []
})
export class ActivityRowBankAggregatorComponent {
  @Input() activity;
}
